import React from "react";

export const Expand = () => (
  <svg width="22px" height="22px">
    <title>Arrow in circle Copy 15</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="OOA-1" transform="translate(-1259.000000, -2226.000000)">
        <g id="Group-3" transform="translate(330.000000, 2203.000000)">
          <g id="Arrow-in-circle" transform="translate(930.000000, 24.000000)">
            <g
              id="Group-13-Copy-2"
              transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
            >
              <circle
                id="Oval"
                stroke="#979797"
                fill="#FFFFFF"
                cx="10"
                cy="10"
                r="10"
              />
              <polygon
                id="+"
                fill="#929292"
                points="10.3386667 9.05466667 12.7266667 9.05466667 12.7266667 10.3386667 10.3386667 10.3386667 10.3386667 12.7266667 9.05466667 12.7266667 9.05466667 10.3386667 6.66666667 10.3386667 6.66666667 9.05466667 9.05466667 9.05466667 9.05466667 6.66666667 10.3386667 6.66666667"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Close = () => (
  <svg width="22px" height="22px">
    <title>Arrow in circle Copy 15</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="OOA-1.1"
        transform="translate(-1259.000000, -2226.000000)"
        stroke="#979797"
      >
        <g id="Group-3" transform="translate(330.000000, 2203.000000)">
          <g
            id="Arrow-in-circle-Copy-7"
            transform="translate(930.000000, 24.000000)"
          >
            <g
              id="Group-13-Copy-2"
              transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
            >
              <circle id="Oval" fill="#FFFFFF" cx="10" cy="10" r="10" />
              <rect
                id="Rectangle"
                fill="#D8D8D8"
                x="7.83333333"
                y="9.83333333"
                width="3.66666667"
                height="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Cross = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
    <path fill="#4A4A4A" fill-rule="nonzero" d="M8.011 6.586l4.57 4.57-1.426 1.425-4.57-4.57-4.59 4.59L.57 11.177l4.59-4.59-4.57-4.57L2.017.591l4.57 4.57L11.176.57l1.426 1.425z"/>
  </svg>
);
